module.exports = __webpack_public_path__ + "img/money.805f92c3.svg";